import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'gbc-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    imports: [AsyncPipe],
})
export class TabComponent implements OnInit {
  @Input()
  public name: string;
  @Input()
  public title: string;

  public active: Observable<boolean>;

  constructor(private readonly activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    if (!this.name) {
      console.error(`Please provide a name for the tab with title: ${this.title}`);
    }

    this.active = this.activatedRoute.params.pipe(map((params) => params.tab === this.name));
  }
}
